(function () {
  "use strict";

  // Headless browsers (Lighthouse, automated audits, bots) — set by the inline
  // pixel block in layout/theme.liquid. Skip all CAPI/pixel work for these so
  // we don't pollute Reddit Ads Manager with non-human events.
  if (window.__rdtSkip) return;

  var cfg = window.__evryRedditCfg;
  if (!cfg || !cfg.endpoint) return;

  // Tapcart's webbridge SDK adds the `tapcart-webbridge` body class asynchronously
  // after its defer script runs, which can race with our defer script. Check at
  // event-firing time (not script init) and combine with a UA sniff so we bail
  // even if the class hasn't been applied yet.
  function isTapcart() {
    if (document.body && document.body.classList.contains("tapcart-webbridge")) return true;
    if (/Tapcart/i.test(navigator.userAgent || "")) return true;
    return false;
  }

  function uuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
      });
    } catch (e) {
      return "fallback-" + Date.now() + "-" + Math.random().toString(36).slice(2);
    }
  }

  function getCookie(name) {
    var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? decodeURIComponent(m[2]) : "";
  }

  function track(eventName, metadata, options) {
    if (isTapcart()) return;
    var opts = options || {};
    // opts.conversionId lets a caller share an ID across pixel and CAPI for
    // Reddit-side dedup (used for PageVisit, where the pixel side is fired
    // inline in theme.liquid rather than through this track() function).
    var conversionId = opts.conversionId || uuid();
    var meta = metadata || {};

    // 1. Browser pixel — same conversion_id used by CAPI for Reddit-side dedupe.
    // The Pixel's field for monetary value is `value` (decimal), while CAPI
    // uses `value_decimal`. Rename for the pixel call only so Events Manager
    // doesn't flag pixel events as "missing value."
    // Skipped via opts.skipPixel for events whose pixel side is fired elsewhere
    // (e.g., PageVisit — the legacy rdt('track', 'PageVisit') in theme.liquid).
    if (!opts.skipPixel && typeof window.rdt === "function") {
      try {
        var pixelMeta = Object.assign({ conversion_id: conversionId }, meta);
        if (typeof pixelMeta.value_decimal === "number") {
          pixelMeta.value = pixelMeta.value_decimal;
          delete pixelMeta.value_decimal;
        }
        window.rdt("track", eventName, pixelMeta);
      } catch (e) {
        /* swallow — never break the storefront on a tracking error */
      }
    }

    // 2. Server-side via Cloudflare Worker. Email/customer_id are sent plaintext
    // over HTTPS to our own subdomain (capi.evryjewels.com); the Worker SHA-256s
    // before forwarding to Reddit. This keeps hashing logic centralized.
    var payload = {
      event_type: eventName,
      conversion_id: conversionId,
      click_id: getCookie("rdt_cid"),
      user: {},
      metadata: metadata || {},
    };
    if (cfg.customerEmail) payload.user.email = cfg.customerEmail;
    if (cfg.customerId) payload.user.external_id = cfg.customerId;

    try {
      // keepalive=true so AddToCart's POST survives the page navigating to the cart.
      // Note: keepalive bodies are spec-capped at 64 KiB — fine for current events,
      // but keep payloads small if more events are added.
      fetch(cfg.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: "omit",
      }).catch(function () {
        /* swallow */
      });
    } catch (e) {
      /* swallow */
    }
  }

  window.evryReddit = { track: track };

  // -------- PageVisit (CAPI side) --------
  // The Reddit Pixel block in theme.liquid fires rdt('track', 'PageVisit', { conversion_id })
  // with a UUID stashed on window.__rdtPageVisitId. We reuse the same ID here so Reddit
  // dedupes the pixel and CAPI signals as one event. skipPixel:true avoids double-firing
  // the pixel side (the inline block already did it).
  track("PageVisit", {}, {
    skipPixel: true,
    conversionId: window.__rdtPageVisitId,
  });

  // -------- ViewContent on product pages --------
  // This theme strips Shopify.meta, so cfg.product is set from Liquid in
  // theme.liquid when request.page_type == 'product'.
  var viewContentFired = false;
  function fireViewContent() {
    if (viewContentFired) return;
    var p = cfg.product;
    if (!p || !p.variantId) return;

    // Reddit's ViewContent event only accepts `products[]` in metadata —
    // sending `value_decimal` or `currency` triggers "Unsupported metadata"
    // warnings in Events Manager. Those fields belong on AddToCart / Purchase.
    track("ViewContent", {
      products: [
        {
          id: String(p.variantId),
          name: p.title || "",
          category: p.type || "",
        },
      ],
    });
    viewContentFired = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fireViewContent);
  } else {
    fireViewContent();
  }

  // -------- AddToCart via fetch interception --------
  // Every Shopify add-to-cart in this theme goes through /cart/add.js — including
  // the form-redirect-looking flows in wishlist.js, constructor-recommendations.js,
  // and constructor-browse.js, because window.onSubmitAtcForm (assets/product.js)
  // intercepts those forms and re-issues the request as a fetch to /cart/add.js.
  // Wrapping fetch once therefore catches all ATC callsites without touching
  // product.js / cart.js / each app integration.
  var origFetch = window.fetch;
  if (typeof origFetch !== "function") return;

  window.fetch = function () {
    var args = arguments;
    var url = "";
    try {
      var first = args[0];
      url = typeof first === "string" ? first : (first && first.url) || "";
    } catch (e) {
      /* ignore */
    }

    var promise = origFetch.apply(this, args);

    if (url && /\/cart\/add\.js/.test(url)) {
      promise
        .then(function (res) {
          if (!res || !res.ok) return;
          if (isTapcart()) return;
          // Clone the response before any other consumer reads its body.
          // Safe here because this .then is the first attached to the promise
          // (cart.js's `await fetch(...)` continuation runs after our .then is
          // registered, so the body is still pristine when we clone).
          var clone = res.clone();
          clone
            .json()
            .then(function (data) {
              var items = data && data.items ? data.items : data ? [data] : [];
              if (!items.length) return;
              fireAddToCart(items);
              captureRdtCid();
            })
            .catch(function () {
              /* not JSON */
            });
        })
        .catch(function () {
          /* network error — pixel/CAPI not fired, intentional */
        });
    }

    return promise;
  };

  function fireAddToCart(items) {
    var products = items.map(function (it) {
      return {
        id: String(it.variant_id || it.id || ""),
        name: it.product_title || it.title || "",
        category: it.product_type || "",
      };
    });
    var totalCents = items.reduce(function (sum, it) {
      var p =
        typeof it.final_line_price === "number"
          ? it.final_line_price
          : (it.price || 0) * (it.quantity || 1);
      return sum + (p || 0);
    }, 0);
    var itemCount = items.reduce(function (sum, it) {
      return sum + (it.quantity || 1);
    }, 0);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";

    track("AddToCart", {
      products: products,
      currency: currency,
      value_decimal: totalCents / 100,
      item_count: itemCount,
    });
  }

  // Capture the Reddit Click ID into a cart attribute so the order webhook
  // can recover it on Purchase. Only fires once per session.
  var rdtCidCaptured = false;
  function captureRdtCid() {
    if (rdtCidCaptured) return;
    var cid = getCookie("rdt_cid");
    if (!cid) return;
    rdtCidCaptured = true;
    origFetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { rdt_cid: cid } }),
    }).catch(function () {
      rdtCidCaptured = false;
    });
  }
})();
